export default {
  expandInput() {
    $(".search-icon").on("click", function () {
      $(".search > .input").toggleClass("input--show");
      $(".menu-funktioner-container").toggleClass(
        "menu-funktioner-container--hide"
      );
      $(".search > .input").focus();
      $(".search-btn").addClass("search-btn--show");
    });
    $(".search > .input").on("blur", function () {
      setTimeout(function () {
        $(".search > .input").val("");
        $(".search-btn").removeClass("search-btn--show");
        $(".search > .input").removeClass("input--show");
        $(".menu-funktioner-container").removeClass(
          "menu-funktioner-container--hide"
        );
      }, 100);
    });
    if ($(".search > .input").hasClass(".input--show")) {
      $(".menu-funktioner-container").addClass(
        "menu-funktioner-container--hide"
      );
      $(".search-btn").addClass("search-btn--show");
    } else {
      $(".menu-funktioner-container").removeClass(
        "menu-funktioner-container--hide"
      );

      $(".search-btn").removeClass("search-btn--show");
    }
  },
};
